import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { rootRoute } from 'root/RootLayout';

const mainRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'email-login',
});

export const emailLoginRoute = createRoute({
  getParentRoute: () => mainRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./EmailLoginView')),
  validateSearch: z.object({
    token: z.string().optional(),
  }).parse,
});

export const emailSentRoute = createRoute({
  getParentRoute: () => mainRoute,
  path: 'email-sent',
  component: lazyRouteComponent(() => import('./EmailSentView')),
  validateSearch: z.object({
    emailAddress: z.string().email().catch('invalid-email-address'),
  }).parse,
});

export const emailLoginRouteTree = mainRoute.addChildren({ emailLoginRoute, emailSentRoute });
